import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"
import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://media.globaladmissions.com/media/school_logos/university-of-groningen_Fwhd7UH.png'
function GRONIGEN() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>University of Groningen</HighlightedText></>}
        description="Founded in 1614, University of Groningen is one of the oldest and most respected universities in the Netherlands. Known for its research-oriented programs, it excels in a variety of fields including law, medicine, social sciences, and natural sciences. The university attracts a large international student population, contributing to its diverse and dynamic academic environment. "
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
            <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
    


   
      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>  Sertaç Bahadır Afşari</td>
                <td>  Computer Science  </td>
                <td>2022</td>
                <td>8159</td>
                <td>FRC</td>
            </tr>
          
        
        </tbody>
    </table>
</div>

</TwoColumn>
</Container>
<Footer />
        </ AnimationRevealPage>
  )
}

export default GRONIGEN